import { Block, Typography as WebTypography } from '@aloft/toolkit-sui';

export function TooltipContent({
  calculations,
  description,
}: {
  calculations?: string[];
  description?: string;
}) {
  return (
    <Block>
      {calculations?.map((calculation, index) => (
        <WebTypography key={index} variant="body2" color="textOffset">
          {calculation}
        </WebTypography>
      ))}
      <WebTypography variant="body2" color="textOffset">
        {description ?? ''}
      </WebTypography>
    </Block>
  );
}
